import { FC, PropsWithChildren } from 'react';
import { Box } from '@bridebook/ui';
import { WeddingWebsitePhoto } from '@bridebook/web/components/wedding-website/view-mode/website-view/tiles/wedding-website-photo';
import styles from './wedding-website-wrapped-tile.style';

interface IProps extends PropsWithChildren {
  photoUrl?: string;
  order: 'photo-left' | 'photo-right';
}

export const WeddingWebsiteWrappedTile: FC<IProps> = ({ children, photoUrl, order }) => {
  // TODO: handle item height/width using styles only, likely also move to using ImageX component instead of passing url in styles
  if (photoUrl && children) {
    return (
      <Box style={styles.wrapper} data-name="wrapped-tile">
        {photoUrl && (
          <Box style={styles.photoWrapper(order)}>
            <WeddingWebsitePhoto url={photoUrl} />
          </Box>
        )}
        {children && <Box style={styles.nonPhotoWrapper}>{children}</Box>}
      </Box>
    );
  }
  if (photoUrl) {
    return <Box style={styles.wrapper}>{photoUrl && <WeddingWebsitePhoto url={photoUrl} />}</Box>;
  }
  return <Box style={styles.wrapper}>{children}</Box>;
};
